import { Observable } from "rxjs/internal/Observable";
import { AttachmentIdentityInterface, OperationIdentityInterface } from "@nts/std/interfaces";
import { SpoolProcessInterface } from "@nts/std/interfaces";
import { OperationState } from "@nts/std/types";

export class SpoolProcess<TProcessResult> implements SpoolProcessInterface<TProcessResult> {

    CheckProcess$: Observable<{ operationState: OperationState, attachments: AttachmentIdentityInterface[], processResult: TProcessResult; }>;
    state: OperationState;
    operationIdentity: OperationIdentityInterface;
    downloadAttachements: boolean;
    fileName?: string;
    dataToPrint?: string;
    spoolControllerAddress: string;
    attachments: AttachmentIdentityInterface[];
    processResult: TProcessResult;
    printerName?: string;
    printerServiceAgentAddress?: string;

    constructor() { }
}
